import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { NgbModal } from 'node_modules/@ng-bootstrap/ng-bootstrap';
import { Router,ActivatedRoute  } from "@angular/router";
import { Location } from '@angular/common';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { User} from 'src/app/Model/User/user.model';


@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {

  
usersEditForm:FormGroup;
currentUser:User;

userDetails=[];
username;
branch;
role;
branchs;

success;
error;

branchCategories=[];
roleCategories=[];

loggedInUsername
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;

salesRep;

validationMessages = {
'firstName': {
  'required': 'First Name is required'
},
'lastName': {
  'required': 'Last Name is required'
},

'branch': {
  'required': 'Branch is required'
},
'role': {
  'required': 'Role is required'
},
'userID': {
  'required': 'Date of birth is required'
},

};


formErrors = {
'firstName': '',
'lastName': '',
'branch': '',
'userID': '',
'role': '',
};
constructor(private _authenticationService: AuthenticationService,
  private modalService: NgbModal,
  private router: Router, 
  private actroute: ActivatedRoute,
  private _location: Location,
  private fb: FormBuilder) { 

    this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
    if(this.currentUser){
    this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
    this.branch=this.currentUser.branch;
    this.role=this.currentUser.role;

    this.loggedInUsername=this.currentUser.userName;
    this.loggedInUserFullname= this.username;
    this.loggedInUserBranch= this.branch
    this.loggedInUserId=this.currentUser.userName;

   }
  }

ngOnInit(): void {
  this.getRoleCategoriesForForm()
  this.getBranchCategoriesForForm();
  this.actroute.paramMap.subscribe(params => {
    // This is never executed, for route is not recognized
    // let myArray=params.getAll('extra');
    const pid = params.get('extra')
    const username = params.get('extra1')
    console.log(this.username);
    if (pid) {
    //  console.log(this.fullName);
      this.getUserDetailsToEdit(pid, username);
     
    } else {
 
    }
  });


  
  console.log(this._authenticationService.currentUserValue.userName)
  
  this.usersEditForm = this.fb.group({
    actionPerformedBy:new FormControl(this._authenticationService.currentUserValue.userName),
    pid: new FormControl(''),
    firstName: new FormControl('', [Validators.required]),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    email: new FormControl(''),
    userID: new FormControl(''),
    oldUserID: new FormControl(''),
    branch: new FormControl(''),
    role: new FormControl(''),
    oldRole: new FormControl(''),
    color: new FormControl('')
    //purchaseDate: new FormControl(''),
  });



}//End of ngOnInit

getUserDetailsToEdit(pid: string, username: string) {

  this._authenticationService.getUserByID(username).subscribe(
    (userinfo) =>{ 
      this.userDetails=userinfo;

      console.log(this.userDetails);
      this.patchUserEditForm();
    },
    (err) => {
      this.error = err;
    }
  );

}
patchUserEditForm() {
 
this.usersEditForm.patchValue({

   
pid: this.userDetails[0].pid,
firstName: this.userDetails[0].firstName,
middleName: this.userDetails[0].middleName,     
lastName: this.userDetails[0].lastName,
email: this.userDetails[0].email,
userID: this.userDetails[0].userName,
oldUserID: this.userDetails[0].userName,
branch: this.userDetails[0].branch,
role: this.userDetails[0].role,
oldRole: this.userDetails[0].role,
color: this.userDetails[0].color,
 
});
}


addModal(modal){
  //this.getSalesRep(this.branch);
  var finalmessage= "Please enter the name: "

  

this.modalService.open(modal, {
  centered: true,
  backdrop: 'static'
});
  
}

updateUser(){
this.logValidationErrors(this.usersEditForm);

this._authenticationService.updateUser(this.usersEditForm.value)
      .subscribe(//subscribe to Observable
        response => {
        //  console.log('Success!', response);
          this.success = response['SUCCESS'];
          this.usersEditForm.reset;
          document.getElementById("openSuccessModalButton").click();
        },
        error => {
         // console.error('ERROR!', error);
          this.error = error.error.text;
          document.getElementById("openErrorModalButton").click();
        }
      );

}

  
backClicked() {
this._location.back();
}

logValidationErrors(group: FormGroup ): void {
  //get the keys from FormGroup object and checks all the keys
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
    if (abstractControl instanceof FormGroup) {
      this.logValidationErrors(abstractControl);
    } else {
      //clear any previous error
      this.formErrors[key] = '';
      //check Validation of the formControl
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        //if not valid then get the error message of whatever the validation error is from the validationMessage method
        const messages = this.validationMessages[key];
        //for every error in validation get the error key and assign it to the formControl name is formError method
        for (const errorkey in abstractControl.errors) {
          if (errorkey) {
      //      console.log(key);

            this.formErrors[key] += messages[errorkey] + ''
          }
        }
      }
    }

  });
}

getRoleCategoriesForForm(){
  this._authenticationService.getRoleCategoriesForForm().subscribe(
    (res) => {

      this.roleCategories = res;
    },
    (err) => {
      this.error = err;
    }
  );
}


/***************************************************************** */
getBranchCategoriesForForm(){
this._authenticationService.getBranchCategoriesForForm().subscribe(
  (res) => {

    this.branchCategories = res;
  },
  (err) => {
    this.error = err;
  }
);
}




isAdmin() {
return this.currentUser && this.currentUser.role === UserRole.Administrator;
}

isSystemAdmin() {
return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
}


isEmployee() {
return this.currentUser && this.currentUser.role === UserRole.Employee;
}





}